'use client';

import styled from 'styled-components';

export const SvgPlaceholder = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    color: currentColor;
    border: 1px solid currentColor;
    border-radius: 6px;
    font-weight: 600;
    line-height: 1;
    font-family: inherit;
`;
